var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C4.21327 8 1.62559 6.61417 0.0995261 4.34646C-0.0331754 4.15748 -0.0331754 3.84252 0.0995261 3.65354C1.62559 1.38583 4.21327 0 7 0C9.78673 0 12.3744 1.38583 13.9005 3.65354C14.0332 3.84252 14.0332 4.15748 13.9005 4.34646C12.3744 6.67717 9.78673 8 7 8ZM1.49289 4.0315C2.81991 5.73228 4.81043 6.74016 7 6.74016C9.18957 6.74016 11.1801 5.73228 12.5071 4.0315C11.1801 2.33071 9.18957 1.32283 7 1.32283C4.81043 1.32283 2.81991 2.33071 1.49289 4.0315Z",
    fill: "#080C27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6C5.86667 6 5 5.06667 5 4C5 2.93333 5.93333 2 7 2C8.06667 2 9 2.93333 9 4C9 5.06667 8.13333 6 7 6ZM7 3.33333C6.6 3.33333 6.33333 3.66667 6.33333 4C6.33333 4.4 6.66667 4.66667 7 4.66667C7.4 4.66667 7.66667 4.33333 7.66667 4C7.66667 3.6 7.4 3.33333 7 3.33333Z",
    fill: "#080C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f54e34ae048a2a5d8ca2fd175156a795.svg";
export { ForwardRef as ReactComponent };